<template>
  <svg width="25" height="24" viewBox="0 0 25 24">
    <path
      d="M17 2.25c.796 0 1.5.896 1.5 2.29.957 0 1.456 2.736 1.497 8.21h.503a1 1 0 0 1 1 1v4.75a1 1 0 0 1-1 1H20v.75a1.5 1.5 0 0 1-3 0v-.75H8v.75a1.5 1.5 0 0 1-3 0v-.75h-.5a1 1 0 0 1-1-1v-4.75a1 1 0 0 1 1-1h.503c.04-5.474.54-8.21 1.497-8.21 0-1.594.733-2.29 1.5-2.29h9zm-2.5 9.041h-4a1 1 0 0 0-1 1V16.5h6v-4.209a1 1 0 0 0-1-1zM7.5 15h-2a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h2A.5.5 0 0 0 8 16v-.5a.5.5 0 0 0-.5-.5zm12 0h-2a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM3.913 6.819a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-3.5a.5.5 0 0 1 .5-.5h.5zm17.665-.023a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-3.5a.5.5 0 0 1 .5-.5h.5zm-9.095-1.398c-1.138 0-2.436.085-3.894.256a1.001 1.001 0 0 0-.817.646L6.624 9.413a.25.25 0 0 0 .235.337h11.28a.25.25 0 0 0 .233-.338l-1.176-3.12a1.001 1.001 0 0 0-.819-.638c-1.458-.17-2.756-.256-3.894-.256z"
      :fill="disabled ? '#ccccc9' : '#1D1D20'"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
